import React from "react";
import { Card, Row, Col } from "react-bootstrap";

const EventStatsCard = ({ stats }) => {
  if (!stats) return null;
  return (
    <Card className="shadow-sm border-0 mt-3">
      <Card.Body>
        <Card.Title className="mb-3 fw-bold">Stats</Card.Title>
        <Row className="mb-2">
          <Col xs={6} className="fw-semibold text-muted">Visitors:</Col>
          <Col>{stats.total_visitors ?? "N/A"}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={6} className="fw-semibold text-muted">Matches:</Col>
          <Col>{stats.total_matches ?? "N/A"}</Col>
        </Row>
        <Row className="mb-2">
          <Col xs={6} className="fw-semibold text-muted">Downloads:</Col>
          <Col>{stats.total_downloaded ?? "N/A"}</Col>
        </Row>
        {/* TODO: add instagram fb et site clicks stats */}
      </Card.Body>
    </Card>
  );
};

export default EventStatsCard;
